import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=1e3b3777"
import script from "./DetailOrder.vue?vue&type=script&lang=ts"
export * from "./DetailOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports